export default __webpack_public_path__ + "static/media/back-3.19020c7c.png";